import React from 'react';

import { DesktopResultContent } from './Desktop/DesktopResultPage';
import { MobileResultContent } from './Mobile/MobileResultPage';
import { ResultContentPageProps } from './types';

export const ResultContent: React.FC<ResultContentPageProps> = ({
  isDesktop,
  isOtherUserBeenPredicted,
  temperamentData,
  ...restProps
}) => {
  const title = isOtherUserBeenPredicted ? `Тип пользователя — ${temperamentData.name}` : `Ваш тип — ${temperamentData.name}`;

  return isDesktop ? (
    <DesktopResultContent
      isDesktop={isDesktop}
      title={title}
      isOtherUserBeenPredicted={isOtherUserBeenPredicted}
      temperamentData={temperamentData}
      {...restProps}
    />
  ) : (
    <MobileResultContent
      isDesktop={isDesktop}
      temperamentData={temperamentData}
      isOtherUserBeenPredicted={isOtherUserBeenPredicted}
      title={title}
      {...restProps}
    />
  );
};
